import { croppingPlanesEqual } from '@/src/store/tools/crop';
import type { View } from '@/src/core/vtk/types';
import { Maybe } from '@/src/types';
import vtkPlane from '@kitware/vtk.js/Common/DataModel/Plane';
import type vtkAbstractMapper from '@kitware/vtk.js/Rendering/Core/AbstractMapper';
import { MaybeRef, unref, watchEffect } from 'vue';

export function useCroppingEffect(
  mapper: vtkAbstractMapper,
  planes: MaybeRef<Maybe<vtkPlane[]>>,
  options?: {
    view?: View;
    /** When false, clipping is cleared and not applied until true. */
    ready?: MaybeRef<boolean>;
  }
) {
  let previousPlanes: vtkPlane[] | null = null;

  watchEffect(() => {
    if (options?.ready !== undefined && !unref(options.ready)) {
      mapper.removeAllClippingPlanes();
      previousPlanes = null;
      return;
    }

    const newPlanes = unref(planes);
    if (!newPlanes) {
      mapper.removeAllClippingPlanes();
      previousPlanes = null;
      options?.view?.requestRender();
      return;
    }

    if (previousPlanes && croppingPlanesEqual(newPlanes, previousPlanes)) {
      return;
    }

    mapper.removeAllClippingPlanes();
    newPlanes.forEach((plane) => mapper.addClippingPlane(plane));
    previousPlanes = newPlanes;
    options?.view?.requestRender();
  });
}
